// extracted by mini-css-extract-plugin
export var tocpicsGobackBtn = "bC_fd";
export var topicsFilterContainer = "bC_fb";
export var topicsFilterWrapper = "bC_fc";